<ion-content [fullscreen]="true" class="page-content">
  <div class="settings-container">
    <div class="page-header">
      <h2 class="page-title">Impostazioni</h2>
    </div>

    <div data-guide="settings-form">
    @for (section of settingsData; track section.id) {
    <div class="settings-section">
      <p class="section-label">
        {{'PAGES.MOBILE_SETTINGS.'+section.label | translate}}
      </p>

      @for (input of section.inputs; track input.id) {
      <div class="soft-input-card">
        <mat-form-field appearance="fill">
          <mat-label>{{'FORM.LABELS.'+input.label | translate}}</mat-label>
          <mat-select [(ngModel)]="input.selectedValue" (selectionChange)="input.touched = true"
            [disabled]="!$any(input).values.length" panelClass="soft-select-panel"> @for (item of $any(input).values;
            track item.id) {
            <mat-option [value]="item.id">
              {{input.disableTranslation ? item.label : ('FORM.LABELS.'+item.label | translate)}}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      }
    </div>
    }

    </div>
    <app-monitoring-preferences data-guide="settings-floors" [mobile]="true" [selectedBuildingId]="monitoringBuildingId"></app-monitoring-preferences>

    <div class="save-btn-container">
      <button data-guide="settings-save" class="soft-save-btn" (click)="saveData()">
        {{'GENERAL.BUTTONS.SAVE_AND_CLOSE' | translate}}
      </button>
    </div>

  </div>
</ion-content>
